/***
 * default prefix "CHAT_VIEW"
 */

export const AT_OPENED_GROUP_ID_SET = 'CHAT_VIEW_OPENED_GROUP_ID_SET';
export const AT_OPENED_CHAT_ID_SET = 'CHAT_VIEW_OPENED_CHAT_ID_SET';
export const AT_CHATS_SET = 'CHAT_VIEW_CHATS_SET';
export const AT_CHAT_UPDATE = 'CHAT_VIEW_CHAT_UPDATE';
export const AT_CHAT_DELETE = 'CHAT_VIEW_CHAT_DELETE';
export const AT_GROUPS_SET = 'CHAT_VIEW_GROUPS_SET';
export const AT_GROUP_UPDATE = 'CHAT_VIEW_GROUP_UPDATE';
export const AT_GROUP_DELETE = 'CHAT_VIEW_GROUP_DELETE';
